import React from 'react'

function RamaMahidol() {
  return (
    <div>โรงพยาบาลรามาธิบดี มหาวิทยาลัยมหิดล</div>
  )
}

export default RamaMahidol